module.exports = __webpack_public_path__ + "static/media/Bål.69e2c693.PNG";